function Progress() {
  return (
    <div className="page-container py-10 sm:py-12">
      <h1 className="page-heading">Progress</h1>
      <p className="text-neutral-300">Progress tracking is coming soon.</p>
    </div>
  );
}

export default Progress;
